(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('NewVendorController', NewVendorController);

    NewVendorController.$inject = ['$state', '$uibModalInstance', 'Vendor', 'AlertService'];

    function NewVendorController($state, $uibModalInstance, Vendor, AlertService) {
        var vm = this;
        vm.vendor = [];

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.save = function () {

            var body = {
                name: vm.vendor.name,
                link: vm.vendor.vendorLink != null ? vm.vendor.vendorLink : null
            };
            Vendor.create(body, onSuccess, onError);

            function onSuccess(data, headers) {
                $uibModalInstance.close();
            }

            function onError() {
                AlertService.error("Name already exist");
            }
        };

    }
})();
